import { InventoryTransactionListPage } from "@/features/inventory-transaction/pages/InventoryTransactionListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/inventory-transaction/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["inventory_transaction.view"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: InventoryTransactionListPage,
});
